import { createFileRoute } from '@tanstack/react-router';

import { ReferencedPostsPage } from '@/features/(insight)/referenced-posts/ui/referenced-posts-page';
import z from 'zod';

const searchSchema = z.object({
  session_id: z.string(),
  block_id: z.string(),
  answer_id: z.string(),
  parts: z.enum(['overview', 'theme']),
  part_id: z.string(),
});

export const Route = createFileRoute('/workspace/$workspaceId/insight/referenced-posts')({
  component: ReferencedPostsPage,
  validateSearch: searchSchema,
});
